<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Listy rezerwowe</span>
        <h3 class="page-title">Pierwsze wizyty</h3>
      </d-col>
      <d-col col sm="6" class="text-right mb-4 mb-sm-0">
        <d-button
          theme="success"
          class="text-nowrap ml-2"
          :disabled="removeInProgress"
          @click.prevent="sendEmails">Wyślij przypomnienia</d-button>
      </d-col>
    </d-row>
    <d-row
      v-if="loaded"
      style="width: 100%;"
      class="d-flex ml-0 mb-3 page-filters">
      <validation-observer
        ref="reservations-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          placeholder="Podaj imię i nazwisko dziecka / wnioskodawcy"
          v-model="filters.search" />
        <v-select
          style="width: 100%;"
          class="ml-2"
          :options="services"
          :reduce="service => service.id"
          v-model="filters.service_id"
          placeholder="Lista usług"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 100%;"
          class="ml-2"
          :options="reasons"
          :reduce="reason => reason.id"
          v-model="filters.reason_id"
          placeholder="Powód zgłoszenia"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="institutions"
          :reduce="institution => institution.id"
          v-model="filters.institution_id"
          placeholder="Lista placówek"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="accountStatusUser"
          v-model="filters.status"
          placeholder="Status"
          :searchable="false"
          label="text">
        </v-select>
        <v-select
          style="width: 50%;"
          class="ml-2"
          :options="reservationPriorities"
          v-model="filters.priority"
          :reduce="priorities => priorities.id"
          placeholder="Ważna wizyta"
          :searchable="false"
          label="name">
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">Szukaj</d-button>

        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">Resetuj filtry</d-button>

        <d-button
          theme="dark"
          outline
          class="text-nowrap ml-2"
          :disabled="downloading !== false"
          @click.prevent="exportList">Eksport</d-button>
      </validation-observer>
    </d-row>
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width reservation-table">
        <thead class="bg-light">
        <tr>
          <th scope="col" class="border-0">Pacjent</th>
          <th scope="col" class="border-0">Dane kontaktowe</th>
          <th scope="col" class="border-0">Placówka</th>
          <th scope="col" class="border-0">Informacje</th>
          <th scope="col" class="border-0">Status</th>
          <th scope="col" class="border-0">Akcje</th>
        </tr>
        </thead>
        <tbody v-if="loaded">
        <tr
          v-for="(reservation, index) of reservationsArr"
          :key="'reservation-' + index">
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '', reservation.user_id !== 0 ? 'custom-priority-blue' : '']">
            {{ reservation.patient_name }} {{ reservation.patient_last_name }}
            <span
              v-if="reservation.medical_information"
              class="tooltip-wrapper"
            >
            ⓘ
            <span class="tooltip-content">
              {{ reservation.medical_information }}
            </span>
            </span>
            <span v-if="reservation.status !== 'RL_TO_ACCEPT'" class="reservation-pesel">
              Numer na liście:
              <span class="reservation-school-value">
                {{ reservation.order_number }}
              </span>
            </span>
            <span class="reservation-pesel">
              PESEL:
              <span class="reservation-pesel-value">
                {{ reservation.patient_pesel }}
              </span>
            </span>
            <span class="reservation-pesel">
              Szkoła:
              <span class="reservation-school-value">
                {{ reservation.school_name }}
              </span>
            </span>
          </td>
          <td
            :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            {{ reservation.guardian_name + ' ' + reservation.guardian_last_name }}
            <span class="reservation-pesel">
              Tel:
              <span class="reservation-school-value">
                {{ reservation.guardian_phone }}
              </span>
            </span>
            <span class="reservation-pesel">
              Email:
              <span class="reservation-school-value">
                {{ reservation.guardian_email }}
              </span>
            </span>
          </td>
          <td
          :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            {{ reservation.institution_name }}
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            <span class="reservation-reason">
              Data zgłoszenia:
              <span class="reservation-reason-value-green">
              {{ reservation.created_at.slice(0, 16) }}
              </span>
            </span>
            <span class="reservation-reason">
              Powód zgłoszenia:
              <span :class="reservation.reason_name ? 'reservation-reason-value-green' : 'reservation-reason-value-shadow'">
              {{ reservation.reason_name ? reservation.reason_name : 'Brak'}}
              </span>
            </span>
            <span class="reservation-reason">
              Wnioskuje o:
              <span :class="reservation.diagnosis_name !== 'brak' ? 'reservation-reason-value' : 'reservation-reason-value-shadow'">
                {{ reservation.diagnosis_name }}
              </span>
            </span>
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']">
            <d-badge
              class="user-status"
              style="width: 12rem;"
              :theme="reservation.status === 'RL_TO_ACCEPT' ? 'primary' : 'success'">
              {{ reservation.status === 'RL_TO_ACCEPT' ? 'Do zaakceptowania' : 'Zaakceptowane' }}
            </d-badge>
          </td>
          <td :class="['align-middle', reservation.priority === 1 ? 'custom-priority-red' : '']"
            style="width: 220px; white-space: nowrap;">
            <d-dropdown
              v-if="reservation.service_id !== 0"
              :disabled="reservation.status !== 'RL_TO_ACCEPT'"
              class="dropdownStatus mr-2"
              :theme="reservation.status === 'RL_TO_ACCEPT' ? 'secondary' : 'success'"
              :menu-id="`dropdown-${reservation.id}`"
              :text="reservation.status === 'RL_TO_ACCEPT' ? 'Zmień status' : 'Zaakceptowane'">
              <d-dropdown-item>
                <d-button
                  style="width: 100%"
                  theme="success"
                  @click="handleAccepted(reservation.id)"
                  :menu-id="`dropdown-accepted-${reservation.id}`">
                  Zaakceptuj
                </d-button>
              </d-dropdown-item>
            </d-dropdown>
            <d-button
              theme="primary"
              class="mr-2"
              @click.prevent="goToReservationDetails(reservation.id)"
              title="Szczegóły wniosku">
              <i class="material-icons">search</i>
            </d-button>
            <d-button
              theme="danger"
              class="mr-2"
              @click.prevent="removeReservation(reservation.id)"
              title="Usuń wniosek">
              <i class="material-icons">delete</i>
            </d-button>
          </td>
        </tr>
        <tr v-if="reservationsArr.length === 0">
          <td
            colspan="6"
            class="text-center">
            Brak rezerwacji do wyświetlenia&hellip;
          </td>
        </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <div class="reservation-legend">
      <div class="reservation-legend-box">
        Rezerwacja z podwyższonym priorytetem
        <span class="red"></span>
      </div>
      <div class="reservation-legend-box">
        Rezerwacja dodana przez specjalistów
        <span class="blue"></span>
      </div>
    </div>
    <pagination :meta-data="paginationMetaData" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';
import HasFilters from './../../mixins/HasFilters.vue';
import HasPagination from './../../mixins/HasPagination.vue';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from './../../components/common/Pagination.vue';
import VisitsFormPatientPopup from '../../components/forms/Visits/VisitsFormPatientPopup';
import Vue from 'vue';
import axios from 'axios';
import api from '@/api';

export default {
  name: 'reservation-list-first',
  mixins: [
    HasFilters,
    HasPagination
  ],
  components: {
    VisitsFormPatientPopup,
    'pagination': Pagination
  },
  computed: {
    accountStatusUser () {
      return [
        {
          value: 'RL_TO_ACCEPT',
          text: 'Wnioski do zaakceptowania'
        },
        {
          value: 'RL_ACCEPTED',
          text: 'Wnioski zaakceptowane'
        }
      ];
    },
    reservationPriorities () {
      return [
        {
          id: 0,
          name: 'NIE'
        },
        {
          id: 1,
          name: 'TAK'
        }
      ];
    }
  },
  data() {
    return {
      institutions: [],
      reservations: [],
      reservationsArr: [],
      singleReservation: [],
      services: [],
      reasons: [],
      removeInProgress: false,
      downloading: false,
      loaded: false,
      loadError: false,
      filters: {
        search: '',
        status: '',
        priority: '',
        institution_id: '',
        service_id: '',
        reason_id: '',
      }
    };
  },
  watch: {
    reservations () {
      this.getNewReservationNew();
    },

    services(newVal) {
      if (newVal && newVal.length && newVal[0].id !== 0) {
        this.services.unshift({ id: 0, name: 'Brak usługi' });
      }
    }
  },
  mounted () {
    this.loadFilteredData();
    this.loadInstitutionsListData();
    this.loadServicesListData();
    this.loadReasons();
  },
  methods: {
    getNewReservationNew() {
      const reservations = this.reservations;
      let arr = [];
      for (let i = 0; i < reservations.length; i++) {
        if (reservations[i].type !== 'RL_ANOTHER_VISIT') {
          arr[i] = reservations[i]
        }
      }
      this.reservationsArr = arr.filter(n => n);
    },
    loadInstitutionsListData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'institutions/items',
        outputKey: 'institutions',
      });
    },
    loadReasons() {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'patients/reservation-list/get-reasons',
        outputKey: 'reasons',
      });
    },
    loadServicesListData() {
      FormUtils.loadAdditionalData(this, {
        endpoint: 'services/items',
        outputKey: 'services',
        params: {
          pagination: false
        },
      });

      this.$nextTick(() => {
        if (this.services && this.services.length) {
          this.services.unshift({ id: 0, name: 'Wybierz usługę' });
        }
      });
    },
    goToReservationDetails(id) {
      this.$router.push(`/reservation_list/detale/${id}`);
    },
    removeReservation(id) {
      this.removeInProgress = true;
      ListUtils.removeItem(this, {
        endpointBase: '/patients/reservation-list/remove/',
        id,
        successTitle: 'Usunięto',
        successText: 'Wybrany wniosek został usunięty',
        confirmTitle: 'Czy na pewno chcesz usunąć ten wniosek?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData() {
      let where = {
        search: this.filters.search,
        type: 'RL_FIRST_VISIT'
      };
      if (this.filters.status !== null && this.filters.status && this.filters.status.value) {
        where.status = this.filters.status.value;
      }
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      if (this.filters.priority !== null && this.filters.priority) {
        where.priority = this.filters.priority;
      }
      if (this.filters.service_id !== null && this.filters.service_id >= 0) {
        where.service_id = this.filters.service_id;
      }
      if (this.filters.reason_id !== null && this.filters.reason_id >= 0) {
        where.reason_id = this.filters.reason_id;
      }
      ListUtils.loadItemsData(this, {
        endpoint: '/patients/reservation-list/items?page=' + this.currentPage,
        listField: 'reservations',
        pagination: true,
        params: {
          where
        }
      });
    },
    exportList() {
      let filename = 'eksport_listy.xlsx';
      let where = {
        search: this.filters.search,
        type: 'RL_FIRST_VISIT'
      };
      if (this.filters.status !== null && this.filters.status && this.filters.status.value) {
        where.status = this.filters.status.value;
      }
      if (this.filters.institution_id !== null && this.filters.institution_id) {
        where.institution_id = this.filters.institution_id;
      }
      if (this.filters.priority !== null && this.filters.priority) {
        where.priority = this.filters.priority;
      }
      if (this.filters.service_id !== null && this.filters.service_id >= 0) {
        where.service_id = this.filters.service_id;
      }
      this.downloading = true;
      axios({
        url: `${api}patients/reservation-list/export`,
        method: 'POST',
        data: {
          where
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK',
        });
        this.downloading = false;
      });
    },
    clearFilters() {
      this.loaded = false;
      this.loadError = false;
      this.filters = {
        search: '',
        status: '',
        institution_id: '',
        service_id: ''
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
    },
    sendEmails() {
      this.removeInProgress = true;

      ListUtils.SendReservationListInfo(this, {
        endpointBase: '/patients/reservation-list/send-info',
        successAction: () => {
          this.removeInProgress = false;
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    reservationStatsGet() {
      this.$store.dispatch('patientsReservationStatsGet')
    },
    validateFiltersForm() {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['reservations-filters-form'], this.debouncedLoadFilteredData);
    },
    handleAccepted(reservationID) {
      this.removeInProgress = true;

      ListUtils.AcceptReservationList(this, {
        endpointBase: '/patients/reservation-list/accept/',
        id: reservationID,
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
          this.reservationStatsGet();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/reservation-list.scss";
</style>
